import { isSuccess } from '@orus.eu/result'

import { hasEndorsementCreationPermission } from './endorsement-availability.utils.ts'

import type { SessionAccess } from '#/shared/routing/session-access.ts'

/**
 * Reads the session outside React, for a route `beforeLoad`. Returns false when the session is
 * unavailable (outdated client): no prefetch, and the action stays hidden.
 */
export async function loadCanCreateEndorsement(session: SessionAccess): Promise<boolean> {
  const sessionResult = await session.getSessionResult()
  if (!isSuccess(sessionResult)) return false
  return hasEndorsementCreationPermission(sessionResult.output.allPermissions)
}
